/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SharingRouteImport } from './routes/sharing'
import { Route as MutesRouteImport } from './routes/mutes'
import { Route as LinksRouteImport } from './routes/links'
import { Route as ImportsRouteImport } from './routes/imports'
import { Route as HomeRouteImport } from './routes/home'
import { Route as FriendsRouteImport } from './routes/friends'
import { Route as CircleRouteImport } from './routes/circle'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthAppleCallbackRouteImport } from './routes/auth/apple/callback'

const SharingRoute = SharingRouteImport.update({
  id: '/sharing',
  path: '/sharing',
  getParentRoute: () => rootRouteImport,
} as any)
const MutesRoute = MutesRouteImport.update({
  id: '/mutes',
  path: '/mutes',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksRoute = LinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsRoute = ImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const FriendsRoute = FriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => rootRouteImport,
} as any)
const CircleRoute = CircleRouteImport.update({
  id: '/circle',
  path: '/circle',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAppleCallbackRoute = AuthAppleCallbackRouteImport.update({
  id: '/auth/apple/callback',
  path: '/auth/apple/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/circle': typeof CircleRoute
  '/friends': typeof FriendsRoute
  '/home': typeof HomeRoute
  '/imports': typeof ImportsRoute
  '/links': typeof LinksRoute
  '/mutes': typeof MutesRoute
  '/sharing': typeof SharingRoute
  '/auth/apple/callback': typeof AuthAppleCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/circle': typeof CircleRoute
  '/friends': typeof FriendsRoute
  '/home': typeof HomeRoute
  '/imports': typeof ImportsRoute
  '/links': typeof LinksRoute
  '/mutes': typeof MutesRoute
  '/sharing': typeof SharingRoute
  '/auth/apple/callback': typeof AuthAppleCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/circle': typeof CircleRoute
  '/friends': typeof FriendsRoute
  '/home': typeof HomeRoute
  '/imports': typeof ImportsRoute
  '/links': typeof LinksRoute
  '/mutes': typeof MutesRoute
  '/sharing': typeof SharingRoute
  '/auth/apple/callback': typeof AuthAppleCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/circle'
    | '/friends'
    | '/home'
    | '/imports'
    | '/links'
    | '/mutes'
    | '/sharing'
    | '/auth/apple/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/circle'
    | '/friends'
    | '/home'
    | '/imports'
    | '/links'
    | '/mutes'
    | '/sharing'
    | '/auth/apple/callback'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/circle'
    | '/friends'
    | '/home'
    | '/imports'
    | '/links'
    | '/mutes'
    | '/sharing'
    | '/auth/apple/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  CircleRoute: typeof CircleRoute
  FriendsRoute: typeof FriendsRoute
  HomeRoute: typeof HomeRoute
  ImportsRoute: typeof ImportsRoute
  LinksRoute: typeof LinksRoute
  MutesRoute: typeof MutesRoute
  SharingRoute: typeof SharingRoute
  AuthAppleCallbackRoute: typeof AuthAppleCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sharing': {
      id: '/sharing'
      path: '/sharing'
      fullPath: '/sharing'
      preLoaderRoute: typeof SharingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mutes': {
      id: '/mutes'
      path: '/mutes'
      fullPath: '/mutes'
      preLoaderRoute: typeof MutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links': {
      id: '/links'
      path: '/links'
      fullPath: '/links'
      preLoaderRoute: typeof LinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports': {
      id: '/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof ImportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/friends': {
      id: '/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof FriendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/circle': {
      id: '/circle'
      path: '/circle'
      fullPath: '/circle'
      preLoaderRoute: typeof CircleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/apple/callback': {
      id: '/auth/apple/callback'
      path: '/auth/apple/callback'
      fullPath: '/auth/apple/callback'
      preLoaderRoute: typeof AuthAppleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  CircleRoute: CircleRoute,
  FriendsRoute: FriendsRoute,
  HomeRoute: HomeRoute,
  ImportsRoute: ImportsRoute,
  LinksRoute: LinksRoute,
  MutesRoute: MutesRoute,
  SharingRoute: SharingRoute,
  AuthAppleCallbackRoute: AuthAppleCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
